import { css } from '@inter-ikea-kompis/web-component';
export default class ToggleStyle {
    /**
     * Returns styles.
     *
     * @param options Options object.
     * @returns Styles.
     */
    static getStyle(options) {
        const { color } = options.theme;
        const selected = options.selectedIndex;
        return css `
			.container {
				display: flex;
			}
			button {
				position: relative;
				outline: none;
				border-radius: 0;
				background: none;
				padding: ${5 / 16}rem ${12 / 16}rem;
				margin: 0;
				border: ${1 / 16}rem solid;
				border-color: ${color.border.light};
				color: ${options.disabled ? color.border.light : color.text.dark};
				cursor: ${options.disabled ? 'not-allowed' : 'pointer'};
				font-size: ${12 / 16}rem;
				font-weight: bold;
				text-align: center;
				display: flex;
				align-items: center;
				justify-content: center;
				user-select: none;
			}
			button:hover {
				border-color: ${color.border.default};
			}
			#item-${selected} {
				border-color: ${color.border.dark};
				color: ${color.text.dark};
			}
			${this.getFluidWidth(options)}
			${this.getRtl(options)}
			${this.getOutlineStyle(options)}
			${this.getOutlineBorderRadius(options)}
		`;
    }
    /**
     * Style for fluid width.
     *
     * @param options Options.
     * @returns Style.
     */
    static getFluidWidth(options) {
        if (!options.fluidWidth) {
            return '';
        }
        return css `
			button {
				width: ${100 / options.numberOfItems}%;
			}
		`;
    }
    /**
     * Style for LTR and RTL.
     *
     * @param options Options.
     * @returns Style.
     */
    static getRtl(options) {
        const { color, border } = options.theme;
        if (options.direction === 'rtl') {
            return css `
				button:first-child {
					border-radius: 0 ${border.radius.radius4 / 16}rem ${border.radius.radius4 / 16}rem 0;
				}
				button:last-child {
					border-radius: ${border.radius.radius4 / 16}rem 0 0 ${border.radius.radius4 / 16}rem;
				}
				button:not(:last-child) {
					border-left: none;
				}
				button:only-child {
					border-radius: ${border.radius.radius4 / 16}rem;
				}
				button:hover + button {
					border-right-color: ${color.border.default};
				}
				#item-${options.selectedIndex} + button {
					border-right-color: ${color.border.dark};
				}
			`;
        }
        return css `
			button:first-child {
				border-radius: ${border.radius.radius4 / 16}rem 0 0 ${border.radius.radius4 / 16}rem;
			}
			button:last-child {
				border-radius: 0 ${border.radius.radius4 / 16}rem ${border.radius.radius4 / 16}rem 0;
			}
			button:not(:last-child) {
				border-right: none;
			}
			button:only-child {
				border-radius: ${border.radius.radius4 / 16}rem;
			}
			button:hover + button {
				border-left-color: ${color.border.default};
			}
			#item-${options.selectedIndex} + button {
				border-left-color: ${color.border.dark};
			}
		`;
    }
    /**
     * Returns the outline style when focusing.
     *
     * @param options Options.
     * @returns Style.
     */
    static getOutlineStyle(options) {
        const { focusOutline } = options.theme;
        return css `
			#outline-${options.focusIndex} {
				opacity: ${options.hasFocus ? '1' : '0'};
				z-index: 100;
				position: absolute;
				border-radius: 0;
				box-shadow: 0 0 0 ${focusOutline.width / 16}rem ${focusOutline.color};
				left: -${focusOutline.offset / 16}rem;
				top: -${focusOutline.offset / 16}rem;
				right: -${focusOutline.offset / 16}rem;
				bottom: -${focusOutline.offset / 16}rem;
			}
		`;
    }
    /**
     * Returns the outline border radius.
     *
     * @param options Options.
     * @returns Style.
     */
    static getOutlineBorderRadius(options) {
        const { border } = options.theme;
        const itemLeft = css `
			#outline-${options.focusIndex} {
				border-radius: ${border.radius.radius4 / 16}rem 0 0 ${border.radius.radius4 / 16}rem;
			}
		`;
        const itemRight = css `
			#outline-${options.focusIndex} {
				border-radius: 0 ${border.radius.radius4 / 16}rem ${border.radius.radius4 / 16}rem 0;
			}
		`;
        if (options.focusIndex === 0 && options.direction === 'rtl') {
            return itemRight;
        }
        if (options.numberOfItems - 1 === options.focusIndex && options.direction === 'rtl') {
            return itemLeft;
        }
        if (options.focusIndex === 0) {
            return itemLeft;
        }
        if (options.numberOfItems - 1 === options.focusIndex) {
            return itemRight;
        }
        return '';
    }
}
//# sourceMappingURL=ToggleStyle.js.map